module.exports = __webpack_public_path__ + "static/img/MT@2x.9d9e287d.jpg";